import request from '@/utils/request'
const BASE_URL = '/RpBankCheckIn'

//出纳管理/现金银行登记账
export default {
    list(data) {
        return request({
            url: BASE_URL + '/List',
            method: 'post',
            data
        })
    },
    list2(data) {
        return request({
            url: BASE_URL + '/List2',
            method: 'post',
            data
        })
    },
    //资金日报
    dayList(data) {
        return request({
            url: BASE_URL + '/DayList',
            method: 'post',
            data
        })
    },
    //账户当前余额
    getAmount(data) {
        return request({
            url: BASE_URL + '/GetCurrentAmount',
            method: 'post',
            data
        })
    },
    //资金统计表 和 资金余额表
    bankCheckInSum(data) {
        return request({
            url: BASE_URL + '/GetBankCheckInSum',
            method: 'post',
            data
        })
    },
    info(id) {
        return request({
            url: BASE_URL + '/Info',
            method: 'get',
            params: { id }
        })
    },
    save(data) {
        return request({
            url: BASE_URL + '/Save',
            method: 'post',
            data
        })
    },
    saveList(data) {
        return request({
            url: BASE_URL + '/SaveList',
            method: 'post',
            data
        })
    },
    delete(id) {
        return request({
            url: BASE_URL + '/Delete',
            method: 'post',
            data: { id }
        })
    },
    payDayList(data) {
        return request({
            url: BASE_URL + '/PayDayList',
            method: 'post',
            data
        })
    }
}